import i18n from '@/i18n';


export interface StandardFormType<T = any> {
  value?: T;
  defaultValue?: T;
  onChange?: (values: T) => void;
}

export enum MatchMode {
  // 同时匹配
  ANDMATCH = 'ANDMATCH',
  // 质量包含
  CONTAIN = 'CONTAIN',
  // 质量不包含
  NOTCONTAIN = 'NOTCONTAIN',
  // 质量是
  Is = 'IS',
  // 质量不是
  ISNOT = 'ISNOT',
  // 小于
  Lt = 'LT',
  // 小于等于
  Le = 'LE',
  // 大于
  Gt = 'GT',
  // 大于等于
  Ge = 'GE',
  // 等于
  Eq = 'OR',
  Between = 'BETWEEN',
  // 性能是
  OR = 'OR',
  // 性能不是
  NOT = 'NOT',
  // 必须要满足所有的 Filter values，仅提供给启动指标的[自定义tag]使用
  AND = 'AND',
  // 模糊匹配
  LIKEARRAY = 'LIKEARRAY',
  // 中间匹配
  MIDMATCH = 'MIDMATCH',
  // 性能包含
  MATCH = 'MATCH',
  // 性能不包含
  NOTMATCH = 'NOTMATCH',
  PREFIX = 'PREFIX',
  SUFFIX = 'SUFFIX',
  EXACT = 'EXACT',
  BitOr = 'bitOr',
  BitAnd = 'bitAnd',
  ISEMPTY = 'ISEMPTY',
  NOTEMPTY = 'NOTEMPTY',
  NOTPREFIX = 'NOTPREFIX',
  NOTSUFFIX = 'NOTSUFFIX',
  REGEXP = 'REGEXP',
  REGEXPFAIL = 'REGEXPFAIL',
  // 出错堆栈分词
  TOKENIZATION = 'TOKENIZATION',
  NOTTOKENIZATION = 'NOTTOKENIZATION',
}

export const MATCH_MODE_TEXT: Record<string, string> = {
  [MatchMode.SUFFIX]: i18n.t('开头匹配'),
  [MatchMode.PREFIX]: i18n.t('结尾匹配'),
  [MatchMode.CONTAIN]: i18n.t('匹配'),
  [MatchMode.NOTCONTAIN]: i18n.t('不匹配'),
  [MatchMode.Is]: i18n.t('是'),
  [MatchMode.ISNOT]: i18n.t('不是'),
  [MatchMode.MATCH]: i18n.t('匹配'),
  [MatchMode.NOTMATCH]: i18n.t('不匹配'),
  [MatchMode.Lt]: i18n.t('小于'),
  [MatchMode.Le]: i18n.t('小于等于'),
  [MatchMode.NOT]: i18n.t('不等于'),
  [MatchMode.Gt]: i18n.t('大于'),
  [MatchMode.Ge]: i18n.t('大于等于'),
  [MatchMode.Eq]: i18n.t('等于'),
  [MatchMode.Between]: i18n.t('区间'),
  [MatchMode.OR]: i18n.t('是'),
  [MatchMode.NOT]: i18n.t('不是'),
  [MatchMode.LIKEARRAY]: i18n.t('模糊匹配'),
  [MatchMode.MIDMATCH]: i18n.t('中间匹配'),
  [MatchMode.NOTEMPTY]: i18n.t('不为空'),
  [MatchMode.ISEMPTY]: i18n.t('为空'),
  [MatchMode.NOTPREFIX]: i18n.t('开头不匹配'),
  [MatchMode.NOTSUFFIX]: i18n.t('结尾不匹配'),
  [MatchMode.REGEXP]: i18n.t('正则表达式'),
  [MatchMode.ANDMATCH]: i18n.t('同时匹配'),
  [MatchMode.TOKENIZATION]: i18n.t('分词'),
};

export const ENUM_MATCH_OPTIONS = [
  {
    value: MatchMode.OR,
    label: i18n.t('是'),
  },
  {
    value: MatchMode.NOT,
    label: i18n.t('不是'),
  },
];

/**
 * 版本匹配模式
 */
export const VERSION_MATCH_OPTIONS = [
  {
    value: MatchMode.OR,
    label: i18n.t('是'),
  },
  {
    value: MatchMode.NOT,
    label: i18n.t('不是'),
  },
  {
    value: MatchMode.Gt,
    label: i18n.t('大于'),
  },
  {
    value: MatchMode.Ge,
    label: i18n.t('大于等于'),
  },
  {
    value: MatchMode.Lt,
    label: i18n.t('小于'),
  },
  {
    value: MatchMode.Le,
    label: i18n.t('小于等于'),
  },
  {
    value: MatchMode.Between,
    label: i18n.t('区间'),
  },
  {
    value: MatchMode.MATCH,
    label: i18n.t('匹配'),
  },
  {
    value: MatchMode.NOTMATCH,
    label: i18n.t('不匹配'),
  },
  {
    value: MatchMode.ISEMPTY,
    label: i18n.t('为空'),
  },
  {
    value: MatchMode.NOTEMPTY,
    label: i18n.t('不为空'),
  },
  {
    value: MatchMode.PREFIX,
    label: i18n.t('开头匹配'),
  },
  {
    value: MatchMode.NOTPREFIX,
    label: i18n.t('开头不匹配'),
  },
  {
    value: MatchMode.SUFFIX,
    label: i18n.t('结尾匹配'),
  },
  {
    value: MatchMode.NOTSUFFIX,
    label: i18n.t('结尾不匹配'),
  },
  {
    value: MatchMode.REGEXP,
    label: i18n.t('正则表达式'),
  },
];

/**
 * 数值匹配模式
 */
export const NUMBER_MATCH_OPTIONS = [
  {
    value: MatchMode.Gt,
    label: i18n.t('大于'),
  },
  {
    value: MatchMode.Ge,
    label: i18n.t('大于等于'),
  },
  {
    value: MatchMode.Eq,
    label: i18n.t('等于'),
  },
  {
    value: MatchMode.NOT,
    label: i18n.t('不等于'),
  },
  {
    value: MatchMode.Lt,
    label: i18n.t('小于'),
  },
  {
    value: MatchMode.Le,
    label: i18n.t('小于等于'),
  },
  {
    value: MatchMode.Between,
    label: i18n.t('区间'),
  },
];

export const STRING_ARRAY_MATCH_OPTIONS = [
  {
    value: MatchMode.MATCH,
    label: i18n.t('不匹配'),
  },
  {
    value: MatchMode.NOTMATCH,
    label: i18n.t('匹配'),
  },
  {
    value: MatchMode.LIKEARRAY,
    label: i18n.t('模糊匹配'),
  },
];

/**
 * 字符串匹配模式
 */
export const CHARACTER_MATCH_OPTIONS = [
  {
    value: MatchMode.OR,
    label: i18n.t('是'),
  },
  {
    value: MatchMode.NOT,
    label: i18n.t('不是'),
  },
  {
    value: MatchMode.MATCH,
    label: i18n.t('匹配'),
  },
  {
    value: MatchMode.NOTMATCH,
    label: i18n.t('不匹配'),
  },
  {
    value: MatchMode.ANDMATCH,
    label: i18n.t('同时匹配'),
  },
  {
    value: MatchMode.ISEMPTY,
    label: i18n.t('为空'),
  },
  {
    value: MatchMode.NOTEMPTY,
    label: i18n.t('不为空'),
  },
  {
    value: MatchMode.PREFIX,
    label: i18n.t('开头匹配'),
  },
  {
    value: MatchMode.NOTPREFIX,
    label: i18n.t('开头不匹配'),
  },
  {
    value: MatchMode.SUFFIX,
    label: i18n.t('结尾匹配'),
  },
  {
    value: MatchMode.NOTSUFFIX,
    label: i18n.t('结尾不匹配'),
  },
  {
    value: MatchMode.REGEXP,
    label: i18n.t('正则匹配'),
  },
  {
    value: MatchMode.REGEXPFAIL,
    label: i18n.t('正则不匹配'),
  },
];


/**
 * 堆栈字符串匹配模式(新增分词匹配规则)
 */
export const STACK_CHARACTER_MATCH_OPTIONS = [
  {
    value: MatchMode.TOKENIZATION,
    label: i18n.t('分词'),
  },
  {
    value: MatchMode.NOTTOKENIZATION,
    label: i18n.t('分词不匹配'),
  },
  {
    value: MatchMode.MATCH,
    label: i18n.t('匹配'),
  },
  {
    value: MatchMode.NOTMATCH,
    label: i18n.t('不匹配'),
  },
  {
    value: MatchMode.OR,
    label: i18n.t('是'),
  },
  {
    value: MatchMode.NOT,
    label: i18n.t('不是'),
  },
  {
    value: MatchMode.ANDMATCH,
    label: i18n.t('同时匹配'),
  },
  {
    value: MatchMode.ISEMPTY,
    label: i18n.t('为空'),
  },
  {
    value: MatchMode.NOTEMPTY,
    label: i18n.t('不为空'),
  },
  {
    value: MatchMode.PREFIX,
    label: i18n.t('开头匹配'),
  },
  {
    value: MatchMode.NOTPREFIX,
    label: i18n.t('开头不匹配'),
  },
  {
    value: MatchMode.SUFFIX,
    label: i18n.t('结尾匹配'),
  },
  {
    value: MatchMode.NOTSUFFIX,
    label: i18n.t('结尾不匹配'),
  },
  {
    value: MatchMode.REGEXP,
    label: i18n.t('正则匹配'),
  },
  {
    value: MatchMode.REGEXPFAIL,
    label: i18n.t('正则不匹配'),
  },
];

/**
 * 字符串数组匹配模式
 */
export const CHARACTER_MATCH_ARRAY_OPTIONS = [
  {
    value: MatchMode.OR,
    label: i18n.t('包含'),
  },
  {
    value: MatchMode.NOT,
    label: i18n.t('不包含'),
  },
  {
    value: MatchMode.AND,
    label: i18n.t('同时包含'),
  },
  {
    value: MatchMode.MATCH,
    label: i18n.t('匹配'),
  },
  {
    value: MatchMode.ANDMATCH,
    label: i18n.t('同时匹配'),
  },
  {
    value: MatchMode.ISEMPTY,
    label: i18n.t('为空'),
  },
  {
    value: MatchMode.NOTEMPTY,
    label: i18n.t('不为空'),
  },
  {
    value: MatchMode.PREFIX,
    label: i18n.t('开头匹配'),
  },
  {
    value: MatchMode.SUFFIX,
    label: i18n.t('结尾匹配'),
  },
];


// 特定类型

export const SPECIFIC_TYPE = [
  { value: MatchMode.OR, label: 'OR' },
  { value: MatchMode.AND, label: 'AND' },
  { value: MatchMode.NOT, label: 'NOT' },
];

// 数据标记特殊类型
export const INFERRED_LABELS_OPTIONS = [
  {
    value: MatchMode.OR,
    label: i18n.t('包含'),
  },
  {
    value: MatchMode.NOT,
    label: i18n.t('不包含'),
  },
  {
    value: MatchMode.AND,
    label: i18n.t('同时包含'),
  },
];


export const TEXT_MATCH_OPTIONS = [
  {
    value: MatchMode.MATCH,
    label: i18n.t('匹配'),
  }];

export interface IMatchModeOptionsType {
  value: MatchMode,
  label: string
}
